module.exports = __webpack_public_path__ + "img/bot-avatar.b3497c1f.png";